// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__3LlDC","meals-appear":"AvailableMeals_meals-appear__3sIaT"};